module.exports = __webpack_public_path__ + "img/busstop_on.432ae6d2.svg";